"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("source-map-support/register");
var shim_1 = require("./shim");
exports.Web3Shim = shim_1.Web3Shim;
var adapter_1 = require("./adapter");
exports.createInterfaceAdapter = adapter_1.createInterfaceAdapter;
//# sourceMappingURL=index.js.map